import React, { CSSProperties } from "react";
import { useTranslation } from "react-i18next";
import * as globals from "../../../src/styles/global.icss.scss";
import { VelavuSite } from "velavu-js-api";
import IconPlace from "../../dynamicicons/icon-place";
import SelectableCard from "../../elements/selectable-card";
import { classArr } from "../../helper/style-helper";
import SiteSwitcherListItem from "./site-switcher-list-item";
import * as styles from "./site-switcher-list.module.scss";
import { NoSitesIcon } from "../../img/icons/icons";

function NoSites() {
	const { t } = useTranslation();

	return (
		<div className={styles.emptyContent}>
			<NoSitesIcon />
			<span className={styles.heading}>
				{t("shared.site_switcher.no_sites_heading")}
			</span>
			<span className={styles.info}>
				{t("shared.site_switcher.no_sites_info")}
			</span>
		</div>
	);
}

type SiteSwitcherListProps = {
	style?: CSSProperties;
	className?: string;

	sites: VelavuSite[];
} & (
	| {
			showGlobal: true;
			onSelectSite: (id: string | undefined) => void;
	  }
	| {
			showGlobal?: false;
			onSelectSite: (id: string) => void;
	  }
);

export default function SiteSwitcherList(props: SiteSwitcherListProps) {
	const { t } = useTranslation();
	let result;
	if (!props.sites.length) {
		result = <NoSites />;
	} else {
		result = (
			<>
				{props.showGlobal && (
					<SelectableCard
						className={`${styles.item} ${styles.globalCard}`}
						onClick={() => props.onSelectSite(undefined)}
					>
						<IconPlace
							color={globals.accent}
							style={{ marginRight: 16 }}
						/>
						<span className={styles.globalLabel}>
							{t("shared.site_switcher.global")}
						</span>
					</SelectableCard>
				)}

				{props.sites.map((site, index) => (
					<SiteSwitcherListItem
						key={site.id}
						className={styles.item}
						site={site}
						onClick={() => props.onSelectSite(site.id)}
					/>
				))}
			</>
		);
	}

	return (
		<div
			style={props.style}
			className={classArr(styles.list, props.className)}
		>
			{result}
		</div>
	);
}
